module.exports = __webpack_public_path__ + "img/yibu.461fb701.png";